<mat-accordion>
  <mat-expansion-panel
    [expanded]="true"
    (click)="click()"
    class="solar-expansion-container"
  >
    <mat-expansion-panel-header>
      <mat-panel-title>
        <ng-container *ngIf="icon">
          <i
            class="fa fa-sort-asc arrow-expansion-panel-customize asc"
            aria-hidden="true"
          ></i>
        </ng-container>
        <ng-container *ngIf="!icon">
          <i
            class="fa fa-sort-desc arrow-expansion-panel-customize desc"
            aria-hidden="true"
          ></i>
        </ng-container>
        <span class="title-header">Solar Energy Statistics</span>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <div
      fxLayout="row wrap"
      fxLayout.xs="column"
      fxLayoutAlign="flex-start flex-start"
    >
      <div
        fxFlex="20%"
        fxFlex.xs="100%"
        fxLayout="row wrap"
        fxLayout.xs="column"
        fxLayoutAlign="left left"
        class="solar-energy-items-container"
      >
        <div
          class="item-header"
          fxLayout="row wrap"
          fxLayout.xs="row"
          fxLayout.sm="column"
          fxFlex="100%"
          fxFlex.xs="100%"
          fxLayoutAlign="center center"
        >
          <div class="energy-title" fxFlex="75%;" fxFlex.xs="100%">Energy</div>
          <div fxFlex="25%" fxFlex.xs="100%">
            <img
              class="widget-images"
              src="./assets/img/dashboard/statistics-energy.png"
              alt="statistics-energy image"
            />
          </div>
        </div>
        <div
          class="item-content"
          fxLayout="row wrap"
          fxLayout.xs="row"
          fxLayout.sm="column"
          fxFlex="100%"
          fxFlex.xs="100%"
          fxLayoutAlign="center center"
        >
          <div
            fxFlex="50%"
            fxFlex.xs="50%"
            fxFlex.sm="100%"
            class="item-content-label"
          >
            LifeTime
          </div>
          <div
            fxFlex="50%"
            fxFlex.xs="50%"
            fxFlex.sm="100%"
            class="item-content-value"
          >
            {{ solarEnergy.energyTillDate }} MWh
          </div>
        </div>
        <div
          class="item-content"
          fxLayout="row wrap"
          fxLayout.xs="row"
          fxLayout.sm="column"
          fxFlex="100%"
          fxFlex.xs="100%"
          fxLayoutAlign="center center"
        >
          <div
            fxFlex="50%"
            fxFlex.xs="50%"
            fxFlex.sm="100%"
            class="item-content-label"
          >
            Yesterday
          </div>
          <div
            fxFlex="50%"
            fxFlex.xs="50%"
            fxFlex.sm="100%"
            class="item-content-value"
          >
            {{ solarEnergy.yestEnergy }} kWh
          </div>
        </div>
        <div
          class="item-content"
          fxLayout="row wrap"
          fxLayout.xs="row"
          fxLayout.sm="column"
          fxFlex="100%"
          fxFlex.xs="100%"
          fxLayoutAlign="center center"
        >
          <div
            fxFlex="50%"
            fxFlex.xs="50%"
            fxFlex.sm="100%"
            class="item-content-label"
          >
            Today
          </div>
          <div
            fxFlex="50%"
            fxFlex.xs="50%"
            fxFlex.sm="100%"
            class="item-content-value"
          >
            {{ solarEnergy.todayEnergy }} kWh
          </div>
        </div>
      </div>

      <div
        fxFlex="20%"
        fxFlex.xs="100%"
        fxLayout="row wrap"
        fxLayout.xs="column"
        fxLayoutAlign="left left"
        class="solar-energy-items-container solar-energy-items-container-padding"
      >
        <div
          class="item-header"
          fxLayout="row wrap"
          fxLayout.xs="row"
          fxLayout.sm="column"
          fxFlex="100%"
          fxFlex.xs="100%"
          fxLayoutAlign="center center"
        >
          <div
            fxFlex="75%;"
            fxFlex.xs="50%"
            fxFlex.sm="100%"
            class="peak-power-title"
          >
            Peak Power
          </div>
          <div fxFlex="25%" fxFlex.xs="50%" fxFlex.sm="100%">
            <img
              class="widget-images"
              src="./assets/img/dashboard/statistics-peak-power.png"
              alt="statistics-peak-power image"
            />
          </div>
        </div>
        <div
          class="item-content"
          fxLayout="row wrap"
          fxLayout.xs="row"
          fxLayout.sm="column"
          fxFlex="100%"
          fxFlex.xs="100%"
          fxLayoutAlign="center center"
        >
          <div
            fxFlex="50%"
            fxFlex.xs="50%"
            fxFlex.sm="100%"
            class="item-content-label"
          >
            LifeTime
          </div>
          <div
            fxFlex="50%"
            fxFlex.xs="50%"
            fxFlex.sm="100%"
            class="item-content-value"
          >
            {{ solarEnergy.maxPowerTillDate }} kW
          </div>
        </div>
        <div
          class="item-content"
          fxLayout="row wrap"
          fxLayout.xs="row"
          fxLayout.sm="column"
          fxFlex="100%"
          fxFlex.xs="100%"
          fxLayoutAlign="center center"
        >
          <div
            fxFlex="50%"
            fxFlex.xs="50%"
            fxFlex.sm="100%"
            class="item-content-label"
          >
            Yesterday
          </div>
          <div
            fxFlex="50%"
            fxFlex.xs="50%"
            fxFlex.sm="100%"
            class="item-content-value"
          >
            {{ solarEnergy.maxPowerYest }} kW
          </div>
        </div>
        <div
          class="item-content"
          fxLayout="row wrap"
          fxLayout.xs="row"
          fxLayout.sm="column"
          fxFlex="100%"
          fxFlex.xs="100%"
          fxLayoutAlign="center center"
        >
          <div
            fxFlex="50%"
            fxFlex.xs="50%"
            fxFlex.sm="100%"
            class="item-content-label"
          >
            Today
          </div>
          <div
            fxFlex="50%"
            fxFlex.xs="50%"
            fxFlex.sm="100%"
            class="item-content-value"
          >
            {{ solarEnergy.maxPowerToday }} kW
          </div>
        </div>
      </div>

      <div
        fxFlex="20%"
        fxFlex.xs="100%"
        fxLayout="row wrap"
        fxLayout.xs="column"
        fxLayoutAlign="left left"
        class="solar-energy-items-container solar-energy-items-container-padding"
      >
        <div
          class="item-header"
          fxLayout="row wrap"
          fxLayout.xs="row"
          fxLayout.sm="column"
          fxFlex="100%"
          fxFlex.xs="100%"
          fxLayoutAlign="center center"
        >
          <div
            fxFlex="75%;"
            fxFlex.xs="50%"
            fxFlex.sm="100%"
            class="revenue-title"
          >
            Revenue
          </div>
          <div fxFlex="25%" fxFlex.xs="50%" fxFlex.sm="100%">
            <img
              class="widget-images"
              src="./assets/img/dashboard/statistics-revenue.png"
              alt="statistics-revenue image"
            />
          </div>
        </div>
        <div
          class="item-content"
          fxLayout="row wrap"
          fxLayout.xs="row"
          fxLayout.sm="column"
          fxFlex="100%"
          fxFlex.xs="100%"
          fxLayoutAlign="center center"
        >
          <div
            fxFlex="50%"
            fxFlex.xs="50%"
            fxFlex.sm="100%"
            class="item-content-label"
          >
            LifeTime
          </div>
          <div
            fxFlex="50%"
            fxFlex.xs="50%"
            fxFlex.sm="100%"
            class="item-content-value"
          >
            {{ solarEnergy.revenueTillDate }} Rs
          </div>
        </div>
        <div
          class="item-content"
          fxLayout="row wrap"
          fxLayout.xs="row"
          fxLayout.sm="column"
          fxFlex="100%"
          fxFlex.xs="100%"
          fxLayoutAlign="center center"
        >
          <div
            fxFlex="50%"
            fxFlex.xs="50%"
            fxFlex.sm="100%"
            class="item-content-label"
          >
            Yesterday
          </div>
          <div
            fxFlex="50%"
            fxFlex.xs="50%"
            fxFlex.sm="100%"
            class="item-content-value"
          >
            {{ solarEnergy.revenueYest }} Rs
          </div>
        </div>
        <div
          class="item-content"
          fxLayout="row wrap"
          fxLayout.xs="row"
          fxLayout.sm="column"
          fxFlex="100%"
          fxFlex.xs="100%"
          fxLayoutAlign="center center"
        >
          <div
            fxFlex="50%"
            fxFlex.xs="50%"
            fxFlex.sm="100%"
            class="item-content-label"
          >
            Today
          </div>
          <div
            fxFlex="50%"
            fxFlex.xs="50%"
            fxFlex.sm="100%"
            class="item-content-value"
          >
            {{ solarEnergy.revenueToday }} Rs
          </div>
        </div>
      </div>

      <div
        fxFlex="20%"
        fxFlex.xs="100%"
        fxLayout="row wrap"
        fxLayout.xs="column"
        fxLayoutAlign="left left"
        class="solar-energy-items-container solar-energy-items-container-padding"
      >
        <div
          class="item-header"
          fxLayout="row wrap"
          fxLayout.xs="row"
          fxLayout.sm="column"
          fxFlex="100%"
          fxFlex.xs="100%"
          fxLayoutAlign="center center"
        >
          <div
            fxFlex="75%;"
            fxFlex.xs="50%"
            fxFlex.sm="100%"
            class="co2-saved-title"
          >
            CO<sub>2</sub> Saved
          </div>
          <div fxFlex="25%" fxFlex.xs="50%" fxFlex.sm="100%">
            <img
              class="widget-images"
              src="./assets/img/dashboard/statistics-co2.png"
              alt="statistics-co2 image"
            />
          </div>
        </div>
        <div
          class="item-content"
          fxLayout="row wrap"
          fxLayout.xs="row"
          fxLayout.sm="column"
          fxFlex="100%"
          fxFlex.xs="100%"
          fxLayoutAlign="center center"
        >
          <div
            fxFlex="50%"
            fxFlex.xs="50%"
            fxFlex.sm="100%"
            class="item-content-label"
          >
            LifeTime
          </div>
          <div
            fxFlex="50%"
            fxFlex.xs="50%"
            fxFlex.sm="100%"
            class="item-content-value"
          >
            {{ solarEnergy.co2TillDate }} Kg
          </div>
        </div>
        <div
          class="item-content"
          fxLayout="row wrap"
          fxLayout.xs="row"
          fxLayout.sm="column"
          fxFlex="100%"
          fxFlex.xs="100%"
          fxLayoutAlign="center center"
        >
          <div
            fxFlex="50%"
            fxFlex.xs="50%"
            fxFlex.sm="100%"
            class="item-content-label"
          >
            Yesterday
          </div>
          <div
            fxFlex="50%"
            fxFlex.xs="50%"
            fxFlex.sm="100%"
            class="item-content-value"
          >
            {{ solarEnergy.co2Yest }} Kg
          </div>
        </div>
        <div
          class="item-content"
          fxLayout="row wrap"
          fxLayout.xs="row"
          fxLayout.sm="column"
          fxFlex="100%"
          fxFlex.xs="100%"
          fxLayoutAlign="center center"
        >
          <div
            fxFlex="50%"
            fxFlex.xs="50%"
            fxFlex.sm="100%"
            class="item-content-label"
          >
            Today
          </div>
          <div
            fxFlex="50%"
            fxFlex.xs="50%"
            fxFlex.sm="100%"
            class="item-content-value"
          >
            {{ solarEnergy.co2Today }} Kg
          </div>
        </div>
      </div>
      <div
        fxFlex="20%"
        fxFlex.xs="100%"
        fxLayout="row wrap"
        fxLayout.xs="column"
        fxLayoutAlign="left left"
        class="solar-energy-items-container solar-energy-items-container-padding"
        style="border-right: 0px !important"
      >
        <div
          class="item-header"
          fxLayout="row wrap"
          fxLayout.xs="row"
          fxLayout.sm="column"
          fxFlex="100%"
          fxFlex.xs="100%"
          fxLayoutAlign="flex-start center"
        >
          <div
            fxFlex="75%;"
            fxFlex.xs="50%"
            fxFlex.sm="100%"
            class="tree-saved-title"
          >
            Tree Saved
          </div>
          <div fxFlex="25%" fxFlex.xs="50%" fxFlex.sm="100%">
            <img
              class="widget-images"
              src="./assets/img/dashboard/statistics-tree-save.png"
              alt="statistics-tree-save image"
            />
          </div>
        </div>
        <div
          class="item-content"
          fxLayout="row wrap"
          fxLayout.xs="row"
          fxLayout.sm="column"
          fxFlex="100%"
          fxFlex.xs="100%"
          fxLayoutAlign="center center"
        >
          <div
            fxFlex="50%"
            fxFlex.xs="50%"
            fxFlex.sm="100%"
            class="item-content-label"
          >
            LifeTime
          </div>
          <div
            fxFlex="50%"
            fxFlex.xs="50%"
            fxFlex.sm="100%"
            class="item-content-value"
          >
            {{ solarEnergy.treessSavedTillDate }} Kg
          </div>
        </div>
        <div
          class="item-content"
          fxLayout="row wrap"
          fxLayout.xs="row"
          fxLayout.sm="column"
          fxFlex="100%"
          fxFlex.xs="100%"
          fxLayoutAlign="center center"
        >
          <div
            fxFlex="50%"
            fxFlex.xs="50%"
            fxFlex.sm="100%"
            class="item-content-label"
          >
            Yesterday
          </div>
          <div
            fxFlex="50%"
            fxFlex.xs="50%"
            fxFlex.sm="100%"
            class="item-content-value"
          >
            {{ solarEnergy.treessSavedYest }} Kg
          </div>
        </div>
        <div
          class="item-content"
          fxLayout="row wrap"
          fxLayout.xs="row"
          fxLayout.sm="column"
          fxFlex="100%"
          fxFlex.xs="100%"
          fxLayoutAlign="center center"
        >
          <div
            fxFlex="50%"
            fxFlex.xs="50%"
            fxFlex.sm="100%"
            class="item-content-label"
          >
            Today
          </div>
          <div
            fxFlex="50%"
            fxFlex.xs="50%"
            fxFlex.sm="100%"
            class="item-content-value"
          >
            {{ solarEnergy.treessSavedToday }} Kg
          </div>
        </div>
      </div>
    </div>
  </mat-expansion-panel>
</mat-accordion>
